import { useEffect } from "react";
import { validateAuthentication } from "services/auth.service";
import { setIsLoadingAuth } from "slices/authReducers";
import { useAppDispatch } from "store/appHooks";
import { handleAuthChange } from "utils/auth.util";

const AuthContainer = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    /**
     * @method: Validate app authentication
     */
    dispatch(setIsLoadingAuth(true));
    validateAuthentication((u: any) => handleAuthChange(u, null, dispatch));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default AuthContainer;
